import styled from 'styled-components';
import { PhotoCarouselMixin } from '../../mixins/components/PhotoCarouselMixin';
export var StyledPhotoCarousel = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPhotoCarousel",
  componentId: "c11n-8-111-1__sc-2dw10y-0"
})(["", ""], PhotoCarouselMixin);